import React from "react";
import tuataraLogo from "../../assets/png/tuataraLogo.png";
import yt from "../../assets/png/youtube.png";
import lindIn from "../../assets/png/linkedin.png";
import fb from "../../assets/png/Fb.png";
import "./footer.css";
import { useNavigate } from "react-router-dom";
import { NZRouterPaths } from "../../router/router";

export default function FooterNZComponent() {
  let navigate = useNavigate();
  const SocialLinks = [
    {
      id: 1,
      image: fb,
      link: "",
    },
    {
      id: 1,
      image: lindIn,
      link: "https://www.linkedin.com/company/tuataraatv/about",
    },
    {
      id: 1,
      image: yt,
      link: "",
    },
    ,
  ];

  return (
    <footer className="footer-nz ">
      <div className="mx-[10px] md:mx-[30px]">
        <div className="custom-container py-[52px]">
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-[50px]">
            <div>
              <div className="text-[#FFFFFF] text-[20px] leading-[26px] uppercase mt-[8px] mb-[22px] montserrat-medium">
                {/* <strong> Headquarters</strong> */}
                <strong> TUATARA NEW ZEALAND - HEAD OFFICE</strong>
              </div>
              {/* <div className="flex text-white mb-[10px] uppercase text-[16px]  montserrat-medium">
                <h4>
                  <strong style={{ color: "rgba(247,135,27,1)" }}>TUATARA ATV</strong>
                  <br />
                  Head Office
                </h4>
              </div> */}
              <p className="mb-[14px] text-[#ffffff]  text-[16px]  montserrat-medium">
                <a
                  href="www.google.com/maps/place/Tuatara+ATV/@-43.5578351,172.377284,15z/data=!4m10!1m2!2m1!1stuatara!3m6!1s0x6d321d3631fd0ee3:0xcae1a6a167efd8d3!8m2!3d-43.5578351!4d172.3963384!15sCgd0dWF0YXJhWgkiB3R1YXRhcmGSARdmYXJtX2VxdWlwbWVudF9zdXBwbGllcuABAA!16s%2Fg%2F1tp1y_mp?authuser=0&amp;entry=ttu"
                  target="_blank"
                >
                  291 Weedons Ross Road, R.D. 5,
                  <br />
                  Christchurch 7675,New Zealand
                </a>
              </p>
              <p className="text-[#ffffff]  text-[16px]  montserrat-medium">
                <strong>Tel.</strong>{" "}
                <a
                  href="tel:+6433474956"
                  target="_blank"
                  className="text-[#E09900]"
                >
                  (+64) 3 347 4956
                </a>
                <br />
              </p>
              <p className="mb-[14px] text-[#ffffff]  text-[16px]  montserrat-medium">
                <strong>Email:</strong>{" "}
                <a
                  href="mailto:info@tuataraatv.com"
                  target="_blank"
                  className="text-[#E09900]"
                >
                  info@tuataraatv.com
                </a>
                <br />
              </p>
              <p className="mb-[14px] text-[#ffffff]">
                <strong>Trading Hours:</strong>
                <br />
                {` Mon-Fri 9:00am - 4:30pm`}
                <br />
                {`Sat 10:00am-3:00pm`}
                <br />
                Closed: Sun
              </p>
            </div>

            <div>
              <div className="text-[#FFFFFF] text-[20px] leading-[26px] uppercase mt-[8px] mb-[22px] montserrat-medium">
                <strong> AUSTRALIAN DEALERS</strong>
              </div>
              <div className="flex text-white mb-[10px]  text-[16px]  montserrat-medium">
                <h4>
                  <strong style={{ color: "rgba(247,135,27,1)" }}>
                    Queensland
                  </strong>
                  <br />
                  Utility Vehicles Queensland
                </h4>
              </div>
              <p className="mb-[14px] text-[#ffffff]  text-[16px]  montserrat-medium">
                1 Robson Street Clontarf QLD 4019, Australia
                {/* <br />
                <strong className="text-[#383838]">.</strong> */}
              </p>
              <p className="text-[#ffffff]  text-[16px]  montserrat-medium">
                <strong>Dealer Principal:</strong>{" "}
                <span className="text-[#E09900]">Craig Henwood</span>
              </p>
              <p className="text-[#ffffff]  text-[16px]  montserrat-medium">
                <strong>Tel:</strong>{" "}
                <a
                  href="tel:+61422501955"
                  target="_blank"
                  className="text-[#E09900]"
                >
                  (+61) 422 501 955
                </a>
                <br />
              </p>
              <p className="text-[#ffffff]  text-[16px]  montserrat-medium">
                <strong>Email:</strong>{" "}
                <a
                  href="mailto:craig@tuatarautv.au"
                  target="_blank"
                  className="text-[#E09900]"
                >
                  craig@tuatarautv.au
                </a>
                <br />
              </p>
              <p className="mb-[14px] text-[#ffffff]  text-[16px]  montserrat-medium">
                <strong>Web:</strong>{" "}
                <a
                  href="www.tuatarautv.au/"
                  target="_blank"
                  className="text-[#E09900]"
                >
                  www.tuatarautv.au
                </a>
                <br />
              </p>
              <p className="mb-[14px] text-[#ffffff]">
                <strong>Trading Hours:</strong>
                <br />
                {` Mon – Fri 8:00am – 5:00pm (Please call first)`}
                <br />
                {`Sat 8:00am-12:00pm`}
                <br />
                Closed: Sun
              </p>
            </div>
            <div>
              <div className="text-[#383838] text-[19px] uppercase mt-[8px] mb-[22px]">
                <strong>.</strong>
              </div>
              <div className="flex text-white mb-[10px]">
                <h4>
                  <strong style={{ color: "rgba(247,135,27,1)" }}>
                    Western Australia
                  </strong>
                  <br />
                  Wing Gear
                </h4>
              </div>
              <p className="mb-[14px] text-[#ffffff]">
                10 Tipping Road, Kewdale WA 6105, Australia
              </p>
              <p className="text-[#ffffff]  text-[16px]  montserrat-medium">
                <strong>Tel:</strong>{" "}
                <a
                  href="tel:+61893523300"
                  target="_blank"
                  className="text-[#E09900]"
                >
                  +61 8 9352 3300
                </a>
                <br />
              </p>
              <p className="text-[#ffffff]">
                <strong>Email:</strong>{" "}
                <a
                  href="mailto:admin@winggear.com.au"
                  target="_blank"
                  className="text-[#E09900]"
                >
                  admin@winggear.com.au
                </a>
                <br />
              </p>

              <p className="mb-[14px] text-[#ffffff]">
                <strong>Web:</strong>{" "}
                <a
                  href="www.winggear.com.au/"
                  target="_blank"
                  className="text-[#E09900]"
                >
                  www.winggear.com.au
                </a>
                <br />
              </p>
              <p className="mb-[14px] text-[#ffffff]">
                <strong>Trading Hours:</strong>
                <br />
                {` Mon-Fri 9:00am – 5:00pm`}
                <br />
                {`(Sat, Sun by appointment)`}
              </p>
            </div>

            <div>
              <div className="flex text-white mb-[10px]">
                <h4>
                  <strong style={{ color: "rgba(247,135,27,1)" }}>
                    Autohaus Rotorua
                  </strong>
                </h4>
              </div>
              {/* <p className="text-[#ffffff]">For Waikato and Bay of Plenty area sales enquiries</p> */}
              <p className="text-[#ffffff]">148 lake Road, Rotorua, 3015</p>
              <p className="text-[#ffffff]">
                <strong>Web:</strong>{" "}
                <a
                  href="www.autohausrotorua.co.nz/"
                  target="_blank"
                  className="text-[#E09900]"
                >
                  www.autohausrotorua.co.nz
                </a>
                <br />
              </p>
              <p className="text-[#ffffff]">
                <strong>Email:</strong>{" "}
                <a
                  href="mailto:info@autohausrotorua.co.nz"
                  target="_blank"
                  className="text-[#E09900]"
                >
                  info@autohausrotorua.co.nz
                </a>
                <br />
              </p>
              <p className="mb-[14px] text-[#ffffff]">
                <strong>Tel:</strong>{" "}
                <a
                  href="tel:+6473487444"
                  target="_blank"
                  className="text-[#E09900]"
                >
                  +64 7 348 7444
                </a>
                <br />
              </p>
              <p className="mb-[14px] text-[#ffffff]">
                <strong>Trading Hours:</strong>
                <br />
                Mon-Fri 8:00am-5:00pm
                <br />
                Saturday (Sales) 9:00am-3:00pm
                <br />
                Closed: Sun
              </p>
            </div>
            <div>
              <div className="flex text-white mb-[10px]">
                <h4>
                  <strong style={{ color: "rgba(247,135,27,1)" }}>
                    Victoria
                  </strong>
                </h4>
              </div>
              <p className="text-[#ffffff]">Sunraysia CME</p>
              <p className="text-[#ffffff]">
                180 Sixth Street, Mildura VIC 3505, Australia
              </p>
              <p className="text-[#ffffff]">
                <strong>Web:</strong>{" "}
                <a
                  href="www.tuataraatv.com.au/"
                  target="_blank"
                  className="text-[#E09900]"
                >
                  www.tuataraatv.com.au
                </a>
                <br />
              </p>
              <p className=" text-[#ffffff]">
                <strong>Email:</strong>{" "}
                <a
                  href="mailto: info@tuataraatv.com.au"
                  target="_blank"
                  className="text-[#E09900]"
                >
                  info@tuataraatv.com.au
                </a>
                <br />
              </p>
              <p className="mb-[14px] text-[#ffffff]">
                <strong>Tel:</strong>{" "}
                <a
                  href="tel:+61427672152"
                  target="_blank"
                  className="text-[#E09900]"
                >
                  +61 427 672 152
                </a>
                <br />
              </p>
              <p className="mb-[14px] text-[#ffffff]">
                <strong>Trading Hours:</strong>
                <br />
                Mon-Fri 8:30am - 5:00pm
                <br />
                Closed Sat-Sun
              </p>
            </div>
            <div>
              <div className="flex text-white mb-[10px]">
                <h4>
                  <strong>International Dealers:</strong>
                </h4>
              </div>
              <p className="text-[#ffffff]">
                Please contact Tuatara Head Office for information regarding our
                European and US dealers.
              </p>
            </div>
            {/* <div>
            <div className="text-[#383838] text-[19px] uppercase mt-[8px] mb-[22px]">
              <strong>.</strong>
            </div>
            <div className="flex text-white mb-[10px]">
              <h4>
                <strong>Queensland Australia</strong>
              </h4>
            </div>
            <p className="mb-[14px] text-[#ffffff]">
              1 Robson St <br />
              Clontarf QLD 4019, Australia
            </p>

            <p className="mb-[14px] text-[#ffffff]">
              <strong>Email:</strong>{" "}
              <a href="mailto:craig@tuatarautv.au" target="_blank" className="text-[#E09900]">
                craig@tuatarautv.au
              </a>
              <br />
            </p>

            <p className="mb-[14px] text-[#ffffff]">
              <strong>Web:</strong>{" "}
              <a href="https://www.tuatarautv.au/" target="_blank" className="text-[#E09900]">
                tuatarautv.au
              </a>
              <br />
            </p>

            <p className="text-[#ffffff]">
              <strong>Open: </strong>Mon – Fri 9 am – 5 pm (Please call first)
            </p>

            <p className="mb-[14px] text-[#ffffff]">
              <strong>Closed: </strong>Sat – Sun
            </p>
            <p className="text-[#ffffff]">
              <strong>Contact: </strong>Craig Henwood on:
            </p>

            <p className="mb-[14px] text-[#ffffff]">
              <strong>Tel.</strong>{" "}
              <a href="tel:+61422501955" target="_blank" className="text-[#E09900]">
                +61 422 501 955
              </a>
              <br />
            </p>
          </div>
          <div>
            <div className="text-[#383838] text-[19px] uppercase mt-[8px] mb-[22px]">
              <strong>.</strong>
            </div>
            <div className="flex text-white mb-[10px]">
              <h4>
                <strong>Victoria and Southern NSW, Australia</strong>
              </h4>
            </div>
            <p className="mb-[14px] text-[#ffffff]">Tuatara ATV Australia</p>
            <p className="mb-[14px] text-[#ffffff]">180 Sixth St, Merbein VIC 3505, Australia,</p>

            <p className="mb-[14px] text-[#ffffff]">
              Tel:{" "}
              <a href="tel:+61427672152" target="_blank" className="text-[#E09900]">
                0427 672152
              </a>
              <br />
            </p>

            <p className="mb-[14px] text-[#ffffff]">
              email:{" "}
              <a href="mailto:info@tuataraatv.com.au" target="_blank" className="text-[#E09900]">
                info@tuataraatv.com.au
              </a>
              <br />
            </p>

            <p className="mb-[14px] text-[#ffffff]">
              Web:{" "}
              <a href="https://www.tuatarautv.com.au/" target="_blank" className="text-[#E09900]">
                tuataraatv.com.au
              </a>
              <br />
            </p>

            <p className="mb-[14px] text-[#ffffff]">Open: 8:30am to 5pm Mon-Fri,</p>

            <p className="mb-[14px] text-[#ffffff]">Closed Sat-Sun</p>
          </div>
          <div>
            <p className="mb-[14px] text-[#ffffff]">
              <strong className="!pb-[14px] text-[#ffffff]">Contacts:</strong>
            </p>
            <p className="mb-[14px] text-[#ffffff]">
              Michelle Morton, National Sales Manager
              <br />
              Tuatara ATV NZ Sales – All Regions
              <br />
              Mob:{" "}
              <a href="tel:+021 564 799" target="_blank" className="text-[#E09900]">
                021 564 799
              </a>
            </p>
            <p className="mb-[14px] text-[#ffffff]">
              Geoff Hill, Managing Director
              <br />
              Tuatara Machinery Ltd / Tuatara ATV
              <br />
              Mob:{" "}
              <a href="tel:+0274 770 070" target="_blank" className="text-[#E09900]">
                0274 770 070
              </a>
            </p>
            <p className="mb-[14px] text-[#ffffff]">
              Please use our{" "}
              <a href="https://tuataraatv.com/contact/" target="_blank" className="text-[#E09900]">
                CONTACT FORM{" "}
              </a>{" "}
              for all New Zealand and International enquiries. We will respond quickly by phone or email. Please use our
            </p>
          </div>
          <div></div>
          <div>
            <div className="flex text-white mb-[10px]">
              <h4>
                <strong>Western Australia</strong>
              </h4>
            </div>
            <p className="mb-[14px] text-[#ffffff]">Wing Gear</p>
            <p className="mb-[14px] text-[#ffffff]">19 Imperial Street, High Wycombe, Perth, WA Australia 6057</p>

            <p className="mb-[14px] text-[#ffffff]">
              email:{" "}
              <a href="mailto:admin@winggear.com.au" target="_blank" className="text-[#E09900]">
                admin@winggear.com.au
              </a>
              <br />
            </p>
            <p className="mb-[14px] text-[#ffffff]">
              Web:{" "}
              <a href="https://winggear.com.au" target="_blank" className="text-[#E09900]">
                winggear.com.au
              </a>
              <br />
            </p>

            <p className="mb-[14px] text-[#ffffff]">Open: Mon-Fri 9am – 5pm (Sat, Sun by appointment)</p>
          </div>
          <div>
            <div className="flex text-white mb-[10px]">
              <h4>
                <strong>International Dealers</strong>
              </h4>
            </div>
            <p className="mb-[14px] text-[#ffffff]">
              Yes, we have dealers in North America and Europe and can ship to other countries.
            </p>
          </div> */}
          </div>
        </div>

        <div className="p-5 flex flex-col gap-3 mt-[55px] border-t border-gray-300">
          <div className="flex items-center justify-center flex-wrap">
            <p
              className="text-[#E09900]  px-[11px] cursor-pointer"
              onClick={() => {
                navigate(NZRouterPaths.Home);
              }}
            >
              Home
            </p>
            <p
              className="text-[#E09900]  px-[11px] cursor-pointer"
              onClick={() => {
                navigate(NZRouterPaths.About);
              }}
            >
              About
            </p>
            <p
              className="text-[#E09900]  px-[11px] cursor-pointer"
              onClick={() => {
                navigate(NZRouterPaths.Petrol);
              }}
            >
              Petrol
            </p>
            <p
              className="text-[#E09900]  px-[11px] cursor-pointer"
              onClick={() => {
                navigate(NZRouterPaths.ElectricAccessories);
              }}
            >
              Electric
            </p>
            <p
              className="text-[#E09900]  px-[11px] cursor-pointer"
              onClick={() => {
                navigate(NZRouterPaths.NzElectricDualMotor);
              }}
            >
              Electric Dual Motor / Dual Cabin
            </p>
            <p
              className="text-[#E09900]  px-[11px] cursor-pointer"
              onClick={() => {
                navigate(NZRouterPaths.NzOrchardised);
              }}
            >
              Orchardised
            </p>
            <p
              className="text-[#E09900]  px-[11px] cursor-pointer"
              onClick={() => {
                navigate(NZRouterPaths.AtvAccessories);
              }}
            >
              Accessories
            </p>
            <p
              className="text-[#E09900]  px-[11px] cursor-pointer"
              onClick={() => {
                navigate(NZRouterPaths.NZGallery);
              }}
            >
              Gallery
            </p>
          </div>
          <img src={tuataraLogo} className="mx-auto w-[205px] h-[82px]" />

          <div className="flex flex-row mx-auto gap-4 mt-[50px]">
            {SocialLinks.map((link) => (
              <a href={link.link} target="_blank" rel="noreferrer">
                <img src={link.image} key={link.id} />
              </a>
            ))}
          </div>
        </div>

        <div className="flex w-full pb-[2rem] pt-[3px] text-center">
          <p className="mx-auto p-2 text-[#c4c4c4] w-full">
            © {new Date().getFullYear()} Tuatara ATV and E-Tuatara are
            registered trademarks.
            <br />
            All other trademarks are the property of their respective owners.
            All rights reserved.
          </p>
        </div>
      </div>
    </footer>
  );
}
